<script lang="ts">
  export let open: boolean = false;
  export let amount: string = ''; // Total amount
  export let employerContribution: string = '';
  export let employeeContribution: string = '';
  export let leaveHours: string = '';
  export let onConfirm: (hourlyRate: number, subtotalAmount: number, totalAmount: number) => void = () => {};
  export let onCancel: () => void = () => {};
  
  $: {
    // The amount passed is already the total, so we just use it directly
  }
  
  function handleConfirm() {
    // Pass dummy values since we're using the direct amounts
    const employeeAmount = parseFloat(employeeContribution) || 0;
    const totalAmount = parseFloat(amount) || 0;
    onConfirm(0, employeeAmount, totalAmount);
  }
</script>

{#if open}
  <div class="modal-backdrop">
    <div class="modal-card">
      <h2 class="modal-title">Confirm Approval</h2>
      <p class="modal-desc">You are about to approve this donation.</p>
      
      <div class="calculation-section">
        <div class="calculation-display">
          <div class="calculation-row">
            <span>Requested Hours:</span>
            <span>{leaveHours} hrs</span>
          </div>
          <div class="calculation-row">
            <span>Employee Contribution:</span>
            <span>${parseFloat(employeeContribution || '0').toFixed(2)}</span>
          </div>
          {#if parseFloat(employerContribution || '0') > 0}
          <div class="calculation-row">
            <span>Employer Matching:</span>
            <span>${parseFloat(employerContribution).toFixed(2)}</span>
          </div>
          {/if}
          <div class="calculation-divider"></div>
          <div class="calculation-row total">
            <span>Total Donation:</span>
            <span>${parseFloat(amount || '0').toFixed(2)}</span>
          </div>
        </div>
      </div>
      
      <p class="modal-detail">By approving, you confirm that your organization will pay Leave2Give this amount, and Leave2Give will distribute it to the selected charity.</p>
      <p class="modal-warning">This action cannot be undone</p>
      <div class="modal-actions">
        <button class="confirm-btn" on:click={handleConfirm}>Confirm & Approve</button>
        <button class="cancel-btn" on:click={onCancel}>Cancel</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(31, 41, 55, 0.4);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-card {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 32px rgba(0,0,0,0.12);
    padding: 32px;
    width: 564px;
    max-width: 95vw;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .modal-title {
    display: block !important;
    color: #111827 !important;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 8px;
    text-align: center;
    z-index: 1;
  }
  .modal-desc {
    font-size: 1rem;
    color: #374151;
    margin-bottom: 24px;
    text-align: center;
    line-height: 1.5;
  }
  .calculation-section {
    width: 100%;
    background: #f8f9fa;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
  }
  
  .calculation-display {
    background: white;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e5e7eb;
  }
  
  .calculation-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    font-size: 0.95rem;
    color: #374151;
  }
  
  .calculation-row.total {
    font-weight: 600;
    font-size: 1.1rem;
    color: #111827;
  }
  
  .calculation-divider {
    height: 1px;
    background: #e5e7eb;
    margin: 8px 0;
  }
  .modal-detail {
    font-size: 1rem;
    color: #374151;
    text-align: center;
    margin-bottom: 12px;
    line-height: 1.5;
  }
  .modal-warning {
    font-size: 0.875rem;
    color: #9ca3af;
    text-align: center;
    margin-bottom: 32px;
    font-style: italic;
  }
  .modal-actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    margin-top: auto;
  }
  .confirm-btn {
    width: 100%;
    height: 52px;
    border-radius: 100px;
    background: #ffc107;
    color: #111827;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    margin-bottom: 0;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .confirm-btn:hover {
    background: #f59e0b;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
  .confirm-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .cancel-btn {
    width: 100%;
    height: 52px;
    border-radius: 100px;
    background: #e5e7eb;
    color: #374151;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    margin-bottom: 0;
    transition: all 0.2s ease;
  }
  .cancel-btn:hover {
    background: #d1d5db;
    transform: translateY(-1px);
  }
  .cancel-btn:active {
    transform: translateY(0);
  }
</style> 